
/**
 * 空状态组件
 * 用于显示无数据时的占位内容
 */
export default {
	name: 'Empty',
	props: {
		description: {
			type: String,
			default: '暂无筛选历史'
		},
	}
}
